'use client';

import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import NextLink from 'next/link';
import { alpha, useTheme } from '@mui/material/styles';

interface HeroSectionProps {
  locale: string;
}

export function HeroSection({ locale }: HeroSectionProps) {
  const t = useTranslations('creator.eventFaqBot.hero');
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.main, 0.12)} 100%)`,
      }}
    >
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h2"
          component="h1"
          fontWeight={800}
          sx={{
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3.25rem' },
            mb: 2,
            color: 'text.primary',
          }}
        >
          {t('title')}
        </Typography>
        <Typography
          variant="h6"
          component="p"
          sx={{
            color: 'text.secondary',
            mb: 4,
            fontSize: { xs: '1rem', md: '1.25rem' },
            maxWidth: 600,
            mx: 'auto',
          }}
        >
          {t('subtitle')}
        </Typography>
        <Button
          component={NextLink}
          href={`/${locale}`}
          variant="contained"
          size="large"
          sx={{
            py: 1.5,
            px: 4,
            fontSize: '1.1rem',
            fontWeight: 600,
            borderRadius: 3,
            textTransform: 'none',
            minWidth: { xs: '100%', sm: 'auto' },
            minHeight: 48,
          }}
        >
          {t('cta')}
        </Button>
      </Container>
    </Box>
  );
}
